import request from '@/utils/request'

// 查询小微企业-党建引领管理列表
export function listDjylgl(query) {
  return request({
    url: '/web/xwqy/djylgl/list',
    method: 'get',
    params: query
  })
}

// 查询小微企业-党建引领管理详细
export function getDjylgl(recid) {
  return request({
    url: '/web/xwqy/djylgl/' + recid,
    method: 'get'
  })
}
